"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("../../../hooks");
var _Icon = _interopRequireWildcard(require("../../../../Icon"));
var _Input = _interopRequireDefault(require("../../../../Input"));
var _InputGroup = _interopRequireDefault(require("../../../../InputGroup"));
var _react = require("react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Password = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
    disabled = props.disabled,
    name = props.name,
    propsOnBlur = props.onBlur,
    propsOnChange = props.onChange,
    visibilityToggleable = props.visibilityToggleable,
    plainTextProps = __rest(props, ["children", "disabled", "name", "onBlur", "onChange", "visibilityToggleable"]);
  var _a = (0, _hooks.useInputLogic)({
      defaultValue: "",
      disabled: disabled,
      name: name
    }),
    additionalInputProps = _a.additionalInputProps,
    clearValidationMessages = _a.clearValidationMessages,
    disabledCombined = _a.disabled,
    inputLogicOnBlur = _a.onBlur,
    setFieldValue = _a.setFieldValue,
    validateOnChange = _a.validateOnChange,
    value = _a.value;
  var _b = (0, _react.useState)(false),
    showPassword = _b[0],
    setShowPassword = _b[1];
  var toggleVisibility = (0, _react.useCallback)(function () {
    setShowPassword(function (currentShowPassword) {
      return !currentShowPassword;
    });
  }, []);
  var onChange = (0, _react.useCallback)(function (event) {
    var _a, _b;
    setFieldValue(name, (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value);
    clearValidationMessages(name);
    validateOnChange(name, (_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.value);
    if (propsOnChange) {
      propsOnChange(event);
    }
  }, [setFieldValue, name, clearValidationMessages, validateOnChange, propsOnChange]);
  var onBlur = (0, _react.useCallback)(function (event) {
    inputLogicOnBlur();
    if (propsOnBlur) {
      propsOnBlur(event);
    }
  }, [inputLogicOnBlur, propsOnBlur]);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsxs)(_InputGroup.default, __assign({
      ref: ref
    }, {
      children: [(0, _jsxRuntime.jsx)(_Input.default, __assign({
        maxLength: additionalInputProps === null || additionalInputProps === void 0 ? void 0 : additionalInputProps.maxLength,
        disabled: disabledCombined,
        id: name,
        name: name,
        value: String(value),
        onChange: onChange,
        onBlur: onBlur,
        type: !visibilityToggleable || !showPassword ? "password" : "text"
      }, plainTextProps)), visibilityToggleable && (0, _jsxRuntime.jsx)(_Icon.default, {
        icon: showPassword ? _Icon.Icons.EyeSlash : _Icon.Icons.Eye,
        onClick: toggleVisibility
      })]
    })), children]
  });
});
var _default = Password;
exports.default = _default;